module.exports = __webpack_public_path__ + "img/logo.c1859c47.svg";